import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';
import { MarketoFormGlobal } from '../../../molecules/marketo-form-global/js/marketo-form-global';
const classes = {
	contactImage: 'js-m-marketo-form__contact-image',
	stateHasImage: 'm-marketo-form__has-contact-image',
	stateAdditionalFieldsVisible: 'm-marketo-form__show-additional-fields',
	stateSuccess: 'state-m-marketo-form--success'
};

@createModule('MarketoForm')
export class MarketoForm extends TerrificSpec {
	$ctx: JQuery;
	$blockedMessage: JQuery;

	formId: string;
	formHref: string;
	formFullId: string;
	envId: string;
	isExpired: boolean;
	redirectHref: string;
	submitSuccessfulMessage: string;
	isHiddenFormSubmit: boolean;
	isSendDataToGtmOnPageLoad: boolean;

	marketoService: MarketoFormGlobal;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$blockedMessage = this.$ctx.find("p[data-id='blockedMsg']");
		this.envId = this.$ctx.data("environment-id");
		this.formId = this.$ctx.data("form-id");
		this.formFullId = `mktoForm_${this.$ctx.data("form-id")}`;
		this.formHref = this.$ctx.data("form-href");
		this.redirectHref = this.$ctx.data("redirect-href");
		this.isExpired = this.$ctx.data("expired");
		this.submitSuccessfulMessage = this.$ctx.data("submitsuccessful-message");
		this.isHiddenFormSubmit = this.$ctx.data("allow-hidden-form-submit");
		this.isSendDataToGtmOnPageLoad = this.$ctx.data("sc-send-data-to-gtm-pageload");
		this.marketoService = new MarketoFormGlobal();

		if (!this.isExpired) {
			this.$blockedMessage.show();

			let timerRef = setInterval(() => {
				let MktoForms2 = (window as any)["MktoForms2"];
				if (typeof (MktoForms2) != "undefined") {
					clearInterval(timerRef);
					this.loadMktoForm();
				}
			}, 300);
		}

		resolve();
	}

	loadMktoForm() {
		let $this = this;

		let MktoForms2 = (window as any)["MktoForms2"];
		if (typeof (MktoForms2) != "undefined") {

			MktoForms2.loadForm($this.formHref, $this.envId, $this.formId, function (form: any) {
				form.onSuccess(function (values: any, followUpUrl: string) {
					Track.setKnownMarketoLead(true);
					$this.submitDataToGtm();
					if ($this.submitSuccessfulMessage.length > 0 || $this.isHiddenFormSubmit == true) {
						$this.$ctx.addClass(classes.stateSuccess);
						$('html, body').animate({
							scrollTop: $this.$ctx.offset().top - 200
						}, 2000);
					}
					else {
						window.location.href = $this.redirectHref;
					}
					//unlock
					$('.a-video--locked').removeClass('a-video--locked');
					$('.m-download-item--locked').removeClass('m-download-item--locked');
					$('.m-download-table__item--locked').removeClass('m-download-table__item--locked');
					$('.m-hero-article-stage--locked').removeClass('m-hero-article-stage--locked');
					$('.m-scrollable-teaser-item--locked').removeClass('m-scrollable-teaser-item--locked');
					$('.m-talk--locked').removeClass('m-talk--locked');
					$('.m-teaser-large--locked').removeClass('m-teaser-large--locked');
					$('.o-teaser-content-area__item').each((i, e) => {
						const $teaser = $(e).children();
						const classList = $teaser.attr('class');
						const className = classList.split(' ');
						$teaser.removeClass(className[0] + '--locked');
					});

					return false;
				});

				form.onSubmit(function () {
					$this.marketoService.formatPhoneNumber(form);
				});

				if (Track.isKnownMarketoLead()) {
					form.vals({ "formVersion": "Known" });
				}

				// Hide blocked test when form is initialized.

				$this.$blockedMessage.hide();
				$this.setFormStartDataToGtm();
			});

			$this.marketoService.initializeMarketoOnScriptLoad();
		}
	}

	submitDataToGtm() {
		let $this = this;
		let formNode = $this.$ctx.find("form")
		let IsSendDataToGtm = formNode.data("sc-send-data-to-gtm");
		if (IsSendDataToGtm) {
			let typeOfForm = formNode.data("form-name");

			const trackdata: {
				event: string;
				form_id: string;
				form_name: string;
				form_destination: string;
				form_submit_text: string;
			} = {
				event: 'form_submit',
				form_id: $(formNode).attr("id"),
				form_name: typeOfForm,
				form_destination: '',
				form_submit_text: '',
			};

			Track.gtmTrack(trackdata);
		}
	}

	setFormStartDataToGtm() {
		let $this = this;
		let formNode = $this.$ctx.find("form")
		let isSendDataToGtmOnPageLoad = formNode.data("sc-send-data-to-gtm-pageload");
		if (isSendDataToGtmOnPageLoad) {
			let typeOfForm = formNode.data("form-name");

			const trackdata: {
				event: string;
				form_id: string;
				form_name: string;
				form_destination: string;
				form_submit_text: string;
			} = {
				event: 'form_start',
				form_id: $(formNode).attr("id"),
				form_name: typeOfForm,
				form_destination: '',
				form_submit_text: '',
			};

			Track.gtmTrack(trackdata);
		}
	}

	stop() { }
}
